import * as d3 from "d3";
import * as d3GeoProjection from "d3-geo-projection";
import * as d3ScaleChromatic from "d3-scale-chromatic";
import {
  sliderBottom,
  sliderLeft,
  sliderRight,
  sliderTop,
} from "d3-simple-slider";


import "../../CSS/jobInfoTable.css";
import "../../CSS/lin_tables.css";
import "../../CSS/mapChart.css";
import "../../CSS/pieChart.css";
import "../../CSS/timeChart.css";

const d3Global = {
  ...d3,
  ...d3GeoProjection,
  ...d3ScaleChromatic,
};

d3Global.sliderBottom = sliderBottom;
d3Global.sliderLeft = sliderLeft;
d3Global.sliderTop = sliderTop;
d3Global.sliderRight = sliderRight;

window.d3 = d3Global;
window.d3SimpleSlider = { sliderBottom, sliderLeft, sliderTop, sliderRight };


import { CONFIG, initAppState } from '../analysis.js';
import "../charts_utils.js";
import "../lin_utils.js";
import "../pieChart.js";
import "../rxiv_utils.js";
import "../timeSeries.js";
import "../worldMap.js";

import { pieChart } from '../pieChart.js';
import { fireReadyEvent } from '../rxiv_utils.js';
import { timeSeriesPlot } from '../timeSeries.js';
import { createHeatMap, displayAll } from "../worldMap.js";

// Expose analysis.js globals for inline scripts in result.php
window.CONFIG = CONFIG;
window.initAppState = initAppState;

// Fire legacy ready events after all visualization globals are exported.
window.pieChart = pieChart;
window.timeSeries = timeSeriesPlot;
window.worldMap = createHeatMap;
window.displayAll = displayAll;

fireReadyEvent('d3-ready');
fireReadyEvent('globals-ready');

